import Vue from 'vue';
import { Settings } from 'luxon';

Vue.Config('i18n').then((config: any) =>
{
    Settings.defaultZoneName = "local";
    Settings.defaultLocale = Vue.i18n.shortLocale();
});
